import { render } from "./CheckSuccess.vue?vue&type=template&id=b8837d74"
import script from "./CheckSuccess.vue?vue&type=script&lang=js"
export * from "./CheckSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__